'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$Args() {
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$Args as $c_Lapp_pages_DocumentTemplatesCreatePage$Args };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$Args.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$Args;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$Args() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$Args as $h_Lapp_pages_DocumentTemplatesCreatePage$Args };
$h_Lapp_pages_DocumentTemplatesCreatePage$Args.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Args.js.map
